import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import LandingBanner from '../LandingBanner';

function SlidingHeader({ images, border = false, showOverlay = true, overlayContent = null }) {
  const styles = {
    bannerContainer: {
      position: 'relative',
      // display: windowWidth >= 768 ? 'block' : 'none',
      width: '100%',
      // height: '100vh',
      overflow: 'hidden',
      backgroundRepeat: 'no-repeat',
      // backgroundPosition: '50%',
      margin: '0 auto',
      zIndex: 0,
      // borderRadius: windowWidth <= 768 ? '0' : '45px',
    },
    bannerImage: {
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      width: '100%',
      height: '100%',
      zIndex: 100,
      position: 'relative',
    },

  };

  return (
    <div style={styles.bannerContainer} className={`banner-container ${border ? 'border-2 border-gray-600' : ''}`}>
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        allowSlideNext={images.length > 0 ? true : false}
        allowSlidePrev={images.length > 0 ? true : false}
        pagination={false}
        centeredSlides={true}
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }} // Ensure full width and correct overflow
        className="swiper-container"
      >
        <SwiperSlide
         style={{ width: '100%', height: '100%' }}>
          <LandingBanner />
        </SwiperSlide>
        {images.map((data, index) => (
          <SwiperSlide key={index} style={{ width: '100%', height: '100%' }}>
            <img
              src={data}
              alt="banner"
              style={{
                width: '100%',
                height: '400px',
                objectFit: 'cover',
                objectPosition: 'center',
                display: 'block'
              }}
            />
          </SwiperSlide>
        ))}
        <SwiperSlide style={{ width: '100%', height: '100%' }}>
          <LandingBanner height="auto" />
        </SwiperSlide>
        {images.map((data, index) => (
          <SwiperSlide key={index} style={{ width: '100%', height: '100%' }}>
            <img
              src={data}
              alt="banner"
              style={{
                width: '100%',
                height: '600px',
                objectFit: 'cover',
                objectPosition: 'center',
                display: 'block'
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      {showOverlay && overlayContent && (
        <div className="pointer-events-none absolute inset-0 z-[220] flex items-center justify-center px-4 md:px-8">
          <div className="pointer-events-auto w-full max-w-[1100px]">
            {overlayContent}
          </div>
        </div>
      )}
    </div>
  )
}
export default SlidingHeader;